import styles from './styles.scss';
import { ProductInformation } from 'views/ProductPage/addToCartPush/themes/BGH/productInformation';
import { useEffect, useRef } from 'react';
import { useDidMount } from '@bygghemmait/hooks';
import { CSS_STICKY_OFFSET_PROP_KEY } from 'components/NewsletterModal/components/StickyTag/stickyTag';
import { selectChannel } from 'components/Header/themes/BGH/selector';
import { useSelector } from 'react-redux';
import { NO_ELEMENT } from 'utils';

interface AddToCartPushProps {
  disabled: boolean;
  children: JSX.Element;
  numberOfSelectedProducts: number;
  isVisible: boolean;
  hasRequiredData: boolean;
}

export const AddToCartPush = ({
  isVisible,
  hasRequiredData,
  disabled,
  numberOfSelectedProducts,
  children
}: AddToCartPushProps) => {
  const channel = useSelector(selectChannel);

  const ref = useRef<HTMLDivElement>(null);
  const rootRef = useRef<HTMLElement>();

  useDidMount(() => {
    const root = document.querySelector<HTMLElement>(':root');
    rootRef.current = root ?? undefined;
  });

  useEffect(() => {
    // Set CSS value to move NewsletterModal's StickyTag above AddToCartPush
    if (rootRef.current) {
      rootRef.current.style.setProperty(
        CSS_STICKY_OFFSET_PROP_KEY,
        `${ref.current?.clientHeight ?? 0}px`
      );
    }
  }, [isVisible]);

  if (channel === 'GOP') {
    // Hide on GOP due to their chat who lies on top of everything on the
    // bottom right corner (when active) colliding with this feature.
    return NO_ELEMENT;
  }

  return (
    <>
      {isVisible && hasRequiredData && (
        <div ref={ref} className={styles.wrapper}>
          <ProductInformation hidden={disabled} amount={numberOfSelectedProducts}>
            {children}
          </ProductInformation>
        </div>
      )}
    </>
  );
};
